import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as StoreState from 'x/modules/store/StoreState'

import LoginView from './LandingView'

export default connect(
  (state) => ({
    //
    selectedStore: state.getIn(['stores', 'selectedStore']),
    myStores: state.getIn(['stores', 'my', 'stores']),
    sellerStores: state.getIn(['stores', 'seller', 'stores']),
    subscription: state.get('subscription'),
    profile: state.get('profile'),
  }),
  (dispatch) => {
    return {
      fetchInitializeData: bindActionCreators(StoreState.fetchInitializeData, dispatch),
      postInitializeData: bindActionCreators(StoreState.postInitializeData, dispatch),
      dispatch,
    }
  }
)(LoginView)
